import React from "react";
import { Card, Grid, Typography } from "@mui/material";

const val = (v: any, suffix = "") => {
  if (v === null || v === undefined || v === "" || v === "-" || v === "N/A") return "-";
  return `${v}${suffix}`;
};

const ExpandRowDetails = ({ data }: { data: any }) => {
  if (!data) return null;

  return (
    <Card variant="outlined" sx={{ p: 2, mb: 1, backgroundColor: "#ffffff" }}>
      <Grid container spacing={2}>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Height</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.height, " cm")}</Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Weight</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.weight, " kg")}</Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Heart Rate</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.heartRate ?? data.heart_rate, " bpm")}</Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Body Mass Index (BMI)</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.bmi, " kg/m²")}</Typography>
        </Grid>

        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Body Fat (%)</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.bodyFat ?? data.body_fat, " %")}</Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Muscle Mass (kg)</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.muscleMass ?? data.muscle_mass, " kg")}</Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Bone Mass (kg)</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.boneMass ?? data.bone_mass, " kg")}</Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Lean Body Mass (kg)</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.leanBodyMass ?? data.lean_body_mass, " kg")}</Typography>
        </Grid>

        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Pediatric BMR Estimate (kcal/day)</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.bmr, " kcal")}</Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Protein (%)</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.protein, " %")}</Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Body Moisture (%)</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.bodyMoisture ?? data.body_moisture, " %")}</Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Visceral Index (Estimated)</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.visceralFat ?? data.visceral_fat)}</Typography>
        </Grid>

        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Subcutaneous Fat (%)</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.subcutaneousFat ?? data.subcutaneous_fat, " %")}</Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Body Type (Estimated)</Typography>
          <Typography variant="body2" fontWeight={600}>{val(data.bodyType ?? data.body_type)}</Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">WHO BMI-for-age</Typography>
          <Typography variant="body2" fontWeight={600} color="#1F497D">
            {val(data.obesityLevel ?? data.obesity_level)}
          </Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Typography variant="caption" color="text.secondary" display="block">Reference Median Weight (P50)</Typography>
          <Typography variant="body2" fontWeight={600} color="#1F497D">
            {val(data.standardWeight ?? data.standard_weight, " kg")}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

export default ExpandRowDetails;
